import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import {
  EmptyState,
  Heading,
  Loading
} from 'components/common/Elements/Elements';
import RolesSettingsTable from './RolesSettingsTable/RolesSettingsTable';

import { getRequest } from 'utils/requests';

import classes from './RolesSettings.module.scss';

const RolesSettings = () => {
  const [rolesList, setRolesList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [dataConection, setDataConection] = useState(false);

  const { t } = useTranslation('settings');

  useEffect(() => {
    let cancelled = false;
    getRequest(`/settings/roles`)
      .then(res => {
        if (!cancelled) {
          setRolesList(res.body);
          setDataConection(true);
          setLoader(false);
        }
      })
      .catch(err => {
        if (!cancelled) {
          setLoader(false);
          console.log(err);
          setDataConection(false);
        }
      });
    return () => (cancelled = true);
  }, []);

  if (loader) {
    return <Loading />;
  }

  return (
    <div className={classes.roles}>
      {dataConection ? (
        <>
          <Heading size={2} className={classes.header} weight="m">
            {t('settings:roles.TITLE_HEADING_ROLES')}
          </Heading>
          <RolesSettingsTable tableData={rolesList} />
        </>
      ) : (
        <EmptyState message="connect" />
      )}
    </div>
  );
};

export default RolesSettings;
